import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { adaptedDataHelper } from 'store/schedule/schedulePageOperation';
import { getEventSheetsFuse } from 'pages/ScheduleV6/utils';

const useV6MonthEvents = () => {
  const { monthSheets, searchValue } = useSelector((state) => state.schedule);
  const timeFormat = useSelector((store) => store.personalProfile.organization?.settings?.timeFormat);

  const events = useMemo(() => {
    const sortedMonthSheets = Object.entries(monthSheets)
      .map(([key, sheets]) => ({
        key,
        sheets: adaptedDataHelper(sheets, timeFormat)
          .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
      }));

    if (!searchValue) {
      return sortedMonthSheets
        .reduce((weekMap, { key, sheets }) => ({ ...weekMap, [key]: sheets }), {});
    }
    const allMonthSheets = sortedMonthSheets.map(({ sheets }) => sheets).flat();
    const fuse = getEventSheetsFuse(allMonthSheets);
    const allFilteredSheets = fuse.search(searchValue);

    const filteredResult = sortedMonthSheets.map(
      ({ key, sheets }) => ({
        key,
        sheets: sheets.filter(sheet => allFilteredSheets.some(s => s._id === sheet._id))
      })
    ).filter(({ sheets }) => sheets.length > 0);
    
    return filteredResult
      .reduce((weekMap, { key, sheets }) => ({ ...weekMap, [key]: sheets }), {});;
  }, [monthSheets, searchValue, timeFormat])

  return { events }
};

export default useV6MonthEvents;